import { 
  Paper, 
  Box, 
  Grid, 
  Typography, 
  FormControlLabel, 
  Checkbox,
} from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import JobsDataTable from './JobsDataTable';
import dateSub from 'date-fns/sub';
import dateAdd from 'date-fns/add';
import dateFormat from 'date-fns/format';
import useServiceRequestSearch, { QueryVars, RequestGroup } from '../hooks/useServiceRequestSearch';
import { Job } from '../JobTypes';

interface Filters {
  todayFilter: boolean,
  yesterdayFilter: boolean,
  pastSevenDaysFilter: boolean,
  [index: string]: boolean;
}

const PAGE_SIZE: number = 10;
const CURRENT_DATE: Date = new Date();
interface Props {
  title?: string
  jobGroup: RequestGroup
}

const JobsPendingWidget = ({title, jobGroup}:Props) => {
  const classes = useStyles();
  const [filters, setFilters] = React.useState<Filters>({todayFilter: true, yesterdayFilter: false, pastSevenDaysFilter: false});
  const [currentPage, setCurrentPage] = React.useState<number>(0);
  const [jobsOnPage, setJobsOnPage] = React.useState<Job[]>([]);
  const QUERY_VARS: QueryVars = React.useMemo(()=>({
    search: {
      requestGroups: [ jobGroup ],
      dateReceivedFrom: dateFormat(CURRENT_DATE, "yyyy-MM-dd'T'00:00:00"),
      dateReceivedTo: dateFormat(dateAdd(CURRENT_DATE,{days:1}), "yyyy-MM-dd'T'00:00:00"),
    },
  }),[jobGroup]);
  const { loading, error, jobData, resultCount, setQueryVars } = useServiceRequestSearch(QUERY_VARS);

  React.useEffect(()=>{
    const tempQueryVars: QueryVars = {
      ...QUERY_VARS,
    };
    if( filters.todayFilter ) {
      tempQueryVars.search.dateReceivedFrom = dateFormat(CURRENT_DATE, "yyyy-MM-dd'T'00:00:00");
      tempQueryVars.search.dateReceivedTo   = dateFormat(dateAdd(CURRENT_DATE,{days:1}), "yyyy-MM-dd'T'00:00:00");
    }
    else if(filters.yesterdayFilter){
      tempQueryVars.search.dateReceivedFrom = dateFormat(dateSub(CURRENT_DATE, {days: 1}), "yyyy-MM-dd'T'00:00:00");
      tempQueryVars.search.dateReceivedTo   = dateFormat(CURRENT_DATE, "yyyy-MM-dd'T'00:00:00");
    }
    else if(filters.pastSevenDaysFilter){
      tempQueryVars.search.dateReceivedFrom = dateFormat(dateSub(CURRENT_DATE, {days: 7}), "yyyy-MM-dd'T'00:00:00");
      tempQueryVars.search.dateReceivedTo   = dateFormat(dateAdd(CURRENT_DATE,{days:1}), "yyyy-MM-dd'T'00:00:00");
    }
    setQueryVars(tempQueryVars);
  },[filters,setQueryVars,QUERY_VARS]);

  React.useEffect(()=>{
    if(!jobData)
      return;

    setJobsOnPage(jobData.slice(currentPage * PAGE_SIZE,(currentPage * PAGE_SIZE + PAGE_SIZE)));
  },[currentPage,jobData]);

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if( !event.target.checked ) {
      event.preventDefault();
      return;
    }

    for (const filterKey in filters) {
      if(filterKey !== event.target.name) {
        filters[filterKey] = false;
      }
    }
    setCurrentPage(0);
    setFilters({...filters, [event.target.name]: event.target.checked });
  };
  const handlePageChange = (_event: Event, pageNumber: number) => {
    setCurrentPage(pageNumber);
  }

  return (
    <Paper className={classes.root} square>
      <Box px={4} py={3}>
        <Grid container alignContent="stretch">
          <Grid item xs={4}>
            <Typography className={classes.widgetTitle} component="h2">{title || 'Pending Jobs'}</Typography>
          </Grid>
          <Grid className={classes.widgetFilters} item container xs={8} justify="flex-end" spacing={2}>
            <Grid item>
              <FormControlLabel
                control={<Checkbox color="primary" checked={filters.todayFilter} onChange={handleFilterChange} name="todayFilter" />}
                label="Today"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={<Checkbox color="primary" checked={filters.yesterdayFilter} onChange={handleFilterChange} name="yesterdayFilter" />}
                label="Yesterday"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={<Checkbox color="primary" checked={filters.pastSevenDaysFilter} onChange={handleFilterChange} name="pastSevenDaysFilter" />}
                label="Past 7 Days"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* { loading && (
        <Grid container justify="center" alignItems="center">
          <Grid item><CircularProgress /></Grid>
        </Grid>
      )} */}
      { error && <div>{error.message}</div> }
      { jobData && 
        <JobsDataTable 
          data={loading ? [] : jobsOnPage} 
          handlePageChange={handlePageChange} 
          currentPage={currentPage}
          pageSize={PAGE_SIZE}
          count={loading ? 0 : resultCount}
          loading={loading}
        /> }
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
	root: {
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  widgetTitle: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.5rem",
    lineHeight: 1.3,
    color: theme.palette.info.main,
  },
  widgetFilters: {
    '& .MuiFormControlLabel-root': {
      lineHeight: 1.5,
      padding: 0,
      margin: 0,
      letterSpacing: 0.15,
    },
    '& .MuiCheckbox-root': {
      padding: 0,
      margin: 0,
    },
  },
}));

export default JobsPendingWidget;